import { extendObservable, computed } from 'mobx'

import { projectApi, segmentApi } from '@atheneum/api'

import Project from '@models/Project.model'
import Segment from '@models/Segment.model'

class ProjectSidebarStore {
  constructor (staticData) {
    extendObservable(this, {
      id: null,
      project: null,
      segments: [],
      staticData,
      subIndustry: computed(() => {
        if (!this.project) return ''
        return staticData.names.subIndustries[this.project.subIndustryId]
      }),
      projectBackground: computed(() => {
        if (!this.project) return ''
        if (!this.project.background) {
          return '-'
        } else {
          return this.project.background
        }
      }),
      loading: false,
      error: null
    })
  }

  async load (id) {
    this.id = Number(id)
    this.project = null
    this.segments = []
    this.total = null
    this.loading = true

    try {
      const project = await projectApi.getOne(id)
      this.project = new Project(project, this.staticData)
      const segments = await segmentApi.getByProject(id)
      this.segments.replace(segments.map(s => new Segment(s)))
    } catch (error) {
      this.error = error
    }

    this.loading = false
  }
}

export default ProjectSidebarStore
